import { t } from '@/i18n';
import { getDomainService } from '@/utils';
import type { z } from 'zod';
import type { ProjectBaseModel } from '../projects/_models/project';

/**
 * 行革からの要望で、2025年以降の基金シートのレイアウトを変更する。
 * すでに公開された内容を変更すると改ざんとみなされるので、2024年度までの事業では旧レイアウトを使用する。
 * ~2024: true
 * 2025~: false
 */
export const isBefore2025 = (
  project?: Pick<z.infer<typeof ProjectBaseModel>, 'fiscalYear'>,
): boolean => {
  return !!project && project.fiscalYear < 2025;
};

/**
 * 行革からの要望で、2026年度の基金シートから「基金への予算措置」の項目名・選択肢名・
 * ポップアップ文言を変更する。
 * すでに公開された内容を変更すると改ざんとみなされるので、2025年度までの基金シートでは旧文言を使用する。
 * ~2025: true
 * 2026~: false
 */
export const isBefore2026 = (
  project?: Pick<z.infer<typeof ProjectBaseModel>, 'fiscalYear'>,
): boolean => {
  return !!project && project.fiscalYear < 2026;
};

/**
 * 年度に応じた「次回予算措置検討年度」の項目名を取得する
 */
export const getNextBudgetMeasureReviewYearLabel = (
  project?: Pick<z.infer<typeof ProjectBaseModel>, 'fiscalYear'>,
): string => {
  return isBefore2026(project)
    ? t('next-budget-review-year')
    : t('expected-grant-decision-period');
};

/**
 * 年度に応じた「次回予算措置検討年度」のポップアップ文言を取得する
 */
export const getNextBudgetMeasureReviewYearHint = (
  project?: Pick<z.infer<typeof ProjectBaseModel>, 'fiscalYear'>,
): string => {
  return isBefore2026(project)
    ? t('hint-next-budget-review-year')
    : t('hint-expected-grant-decision-period');
};

/**
 *  プロジェクト詳細ページのURLを取得
 */
export const getProjectDetailPageUrl = ({
  isPS,
  projectId,
  onlyPath = false,
}: {
  isPS: boolean;
  projectId: string;
  onlyPath?: boolean;
}): string => {
  const path = isPS ? `/project/${projectId}` : `/rs/project/${projectId}`;
  if (onlyPath) {
    return path;
  }
  const domain = getDomainService({ isPS });
  return `${domain}${path}`;
};
